import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { NumberMaskPipe } from '../pipes/number-mask.pipe';

@Directive({
    selector: '[pghNumber]'
})
export class InputNumberDirective implements OnInit {
  constructor(
    private elementRef: ElementRef,
    private numberMask: NumberMaskPipe,
    private ngControl: NgControl
  ) {
    this._nativeRef = this.elementRef.nativeElement;
  }

  private _nativeRef: HTMLInputElement;

  @Input('pghNumber') pattern;
  @Input('pghNumberLength') maxLength;
  @Input('pghNumberHideValue') hideValue = false;

  ngOnInit() {
    if (this.pattern) {
      this._nativeRef.value = this.numberMask.transform(this._nativeRef.value, this.pattern);
    }

    if (this.hideValue && this._nativeRef?.value) {
      this._nativeRef.value = this._nativeRef.value.replace(/\d/g, '•');
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInputChange(value) {
    if (this.maxLength) {
      this.ngControl.control.setValue(value.replace(/[^0-9]/g, '').slice(0, this.maxLength));
    } else {
      this.ngControl.control.setValue(value.replace(/[^0-9]/g, ''));
    }

    if (this.pattern) {
      this._nativeRef.value = this.numberMask.transform(this.ngControl.value, this.pattern);
    }
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus() {
    if (this.hideValue) {
      this._nativeRef.value = this.numberMask.transform(this.ngControl.value, this.pattern);
    }
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    if (this.hideValue) {
      this._nativeRef.value = value.replace(/\d/g, '•');
    }
  }
}
